<template>
    <div class="container p-4">
        <div class="alert alert-success">
            <strong><i class="fas fa-thumbs-up"></i> Réussite</strong> <br>
            Votre enregistrement est à présent terminé !
        </div>
    </div>
</template>

<script>

export default {
    name: 'Success',
}
</script>
